import { VUE_APP_SERVER_ADDRESS } from '@/application.config';

/**
 * URL of an FO-v3 component, carrying a cache-invalidating token.
 *
 * The token is computed on every call — i.e. when the hosting component is
 * mounted — so the URL never has a cache entry and the iframe document is
 * always fetched from the server. Hashed chunks stay cacheable, because only
 * the document URL changes.
 *
 * FO-v2 has no `<keep-alive>` (the single `<router-view />` lives in
 * `src/root/root.vue`), so entering a view remounts its component and
 * `setup()` produces a fresh token.
 */
export const v3Url = (path: string): string => `${VUE_APP_SERVER_ADDRESS}/v3/${path}?t=${Date.now()}`;
